import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { isSameDay, parseISO } from 'date-fns';
import { useLottie } from 'lottie-react';
import SingleCounter from 'components/shared/counters/single/SingleCounter';
import { defaultLottieOptions } from 'common/constants/general';
import routes from 'common/routes';

import trainingIcon from 'lottie/training_icon.json';

function SessionFinishedTodayCounter() {
  const { t } = useTranslation(['sessions']);
  const navigate = useNavigate();

  const isActivePlus = useSelector((state) => state.auth.user.is_active_plus);
  const todayFinishedSessionsCounter = useSelector((state) => state.session.counters.finishedToday);
  const todaySessionsCounter = useSelector((state) => state.session.counters.today);
  const myGroupSessions = useSelector((state) => state.groupSession.data.myGroupSessions);

  const getCounterLines = () => {
    if (isActivePlus) {
      const today = new Date();
      const todayCount = myGroupSessions.filter(
        (s) => s.status === 'SCHEDULED' && isSameDay(parseISO(s.start_date), today)
      ).length;
      if (todayCount === 0) return [t('clearSchedule'), ''];
      return [
        `${todayCount} ${t('session', { count: todayCount })}`,
        t('toComplete', { ns: 'common' })
      ];
    }
    const unfinishedSessions = (todaySessionsCounter ?? 0) - (todayFinishedSessionsCounter ?? 0);
    if ((todaySessionsCounter ?? 0) === 0) return [t('clearSchedule'), ''];
    return [
      unfinishedSessions === 0
        ? t('training')
        : `${unfinishedSessions} ${t('session', { count: unfinishedSessions })}`,
      unfinishedSessions === 0
        ? t('completed', { ns: 'common' })
        : t('toComplete', { ns: 'common' })
    ];
  };

  const [line1, line2] = getCounterLines();

  const lottieOptions = {
    ...defaultLottieOptions,
    animationData: trainingIcon
  };

  const { View } = useLottie(lottieOptions);

  const destination = isActivePlus ? routes.activePlusSessions.path : routes.calendar.path;

  return (
    <SingleCounter
      lottieIcon={View}
      title={t('today', { ns: 'common' })}
      lines={[line1, line2]}
      onClick={() => navigate(destination)}
    />
  );
}

export default SessionFinishedTodayCounter;
